import React, {memo} from "react";
import styles from "./Projects.module.css";
import {getProjectImagePath, Project} from "@/shared/pages/projectsShared";
import ExportedImage from "next-image-export-optimizer";
import Link from "next/link";

type ProjectCardProps = {
    project: Project;
    colClass?: string;
    isFirst?: boolean;
    queryParams?: string;
};

export const ProjectCard = memo(function ProjectCard({
                                                  project,
                                                  colClass = "",
                                                  isFirst = false,
                                                  queryParams = ""
                                              }: ProjectCardProps) {
    return (
        <Link
            href={`/projects/${project.urlSlug}${queryParams}`}
            scroll={false}
            className={`${colClass} ${
                project.featured ? "featured-project" : "normal-project"
            } mb-4`}
            key={project.id}
        >
            <div
                className={`${styles.projectItem} project-item zoom-img rounded-2 fix position-relative border-secondary-subtle border-1 border shadow`}
                style={{ cursor: "pointer" }}
            >
                <ExportedImage
                    className={`${styles.projectImage} rounded-2 object-fit-cover h-100`}
                    src={project.thumbnailUrl ? getProjectImagePath(project.thumbnailUrl) : getProjectImagePath("projects-default.jpg")}
                    alt={project.name}
                    width={project.featured ? 800 : 400}
                    height={project.featured ? 400 : 225}
                    sizes={
                        project.featured
                            ? "(max-width: 768px) 100vw, 50vw"
                            : "(max-width: 768px) 100vw, 25vw"
                    }
                    priority={isFirst}
                />
                <div className="card-team text-start rounded-3 position-absolute bottom-0 start-0 end-0 z-1 backdrop-filter w-auto p-4 m-3 ">
          <span className="shadow-sm d-flex align-items-center bg-white-keep d-inline-flex rounded-pill px-2 py-1 mb-3">
            <span className="bg-primary fs-9 fw-bold rounded-pill px-2 py-1 text-white">
              {project.flags[0] || "Project"}
            </span>
            <span className="fs-7 fw-medium text-primary mx-2">See More</span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={18}
                height={19}
                viewBox="0 0 18 19"
                fill="none"
            >
              <path
                  d="M10.3125 5.5625L14.4375 9.5L10.3125 13.4375"
                  stroke="#007BFC"
                  strokeWidth="1.125"
                  strokeLinecap="round"
                  strokeLinejoin="round"
              />
              <path
                  d="M14.25 9.5H3.5625"
                  stroke="#007BFC"
                  strokeWidth="1.125"
                  strokeLinecap="round"
                  strokeLinejoin="round"
              />
            </svg>
          </span>
                    <h6 className="text-700">{project.name}</h6>
                    <p className="fs-7 mb-2 d-none d-md-none">
                        {project.about?.substring(0, 50)}...
                    </p>
                    <p className="fs-7 mb-2 d-none d-md-block">
                        {project.about?.substring(
                                0,
                                project.featured ? 350 : 50
                            ) +
                            ((project.about?.length || 0) >
                            (project.featured ? 250 : 50)
                                ? "..."
                                : "")}
                    </p>
                    <div className="d-flex flex-wrap gap-2">
                        {project.techStacks.map((tech) => (
                            <span
                                key={tech}
                                className="badge bg-secondary text-white fs-8 font-medium px-2 py-1 rounded"
                            >
                            {tech}
                          </span>
                        ))}
                    </div>
                </div>
                {project.featured && (
                    <span
                        className="position-absolute top-0 start-0 m-3 badge bg-primary text-white fs-6 shadow border-white-keep border-1 border px-2 py-1 rounded"
                        style={{
                            background: "var(--primary-gradient)",
                            color: "white",
                            fontSize: "12px",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontWeight: "bold",
                            zIndex: 2,
                        }}
                    >
                        Featured
                    </span>
                )}
            </div>
        </Link>
    );
});
